import React, { Component } from 'react';
import Slider from "react-slick";
import ParrillaPost from './Parrilla_item';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className + ' icon-circle-right'}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className + ' icon-circle-left'}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}


class ParrillaContent extends Component {

  constructor(props){
    super(props)
    this.state = {
      slider: [],
      activeIndex: 1,
      left: 0
    }
    this.arraydiv = this.arraydiv.bind(this)
  }

  componentDidMount(){
    this.setState({
      slider: this.props.Parrilla
    })
  }

  componentWillReceiveProps(next_props) {
    if(next_props.Parrilla !== this.state.slider){
      this.setState({
        slider: this.arraydiv(next_props.Parrilla)
      })
    }
  }

  arraydiv(arr) {
    var pairs = [];
    for (var i=0 ; i<arr.length ; i+=3) {
      if (arr[i+1] !== undefined) {
          pairs.push ([arr[i], arr[i+1], arr[i+2]])
      } else {
          pairs.push ([arr[i]])
      }
    }
    return pairs
  }


  render() {
    const settings = {
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: 'icon-circle-left',
      classNamer: 'icon-circle-right',
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 20000
    }
    return (
      <div className="container">
        <Slider {...settings}>
          {
          this.state.slider.map((item, i) => {
            return (
              <div className='cont-media' key={i}>
                <div className="row cont-items-media">
                  <div className="col s12 m6 l6">
                    <div className="cont-item">
                      <a href={item[0].categoryLink}>
                        <div className="item-play">
                          <ParrillaPost
                            imgItem={item[0].imgft_field}
                            titleItem={item[0].title.rendered}
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="col s12 m6 l6">
                    <div className="cont-item-img">
                      { item[1] &&
                        <a href={item[1].categoryLink}>
                          <div className="item">
                            <ParrillaPost
                              imgItem={item[1].imgft_field}
                              titleItem={item[1].title.rendered}
                            />
                          </div>
                        </a>
                      }
                      { item[2] &&
                        <a href={item[2].categoryLink}>
                          <div className="item">
                            <ParrillaPost
                              imgItem={item[2].imgft_field}
                              titleItem={item[2].title.rendered}
                            />
                          </div>
                        </a>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        }
        </Slider>
      </div>
    )
  }
}

export default ParrillaContent



// WEBPACK FOOTER //
// ./src/Parrilla.js